webpackJsonp([35783957827783],{

/***/ 88:
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Downloads = function (_Component) {
	  _inherits(Downloads, _Component);
	
	  function Downloads() {
	    _classCallCheck(this, Downloads);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Downloads.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "downloads" },
	      _react2.default.createElement(
	        "a",
	        {
	          className: "app-store",
	          href: "https://itunes.apple.com/de/app/id385255956?mt=8&ign-mpt=uo%3D4"
	        },
	        "Download aus dem App Store"
	      ),
	      _react2.default.createElement(
	        "a",
	        {
	          className: "play-store",
	          href: "https://play.google.com/store/apps/details?id=ch.swift.itheoriede&hl=en_GB"
	        },
	        "Download aus dem Play Store"
	      ),
	      _react2.default.createElement(
	        "a",
	        { className: "web-app", href: "https://elearning.itheorie.de" },
	        "Lernen im Web"
	      )
	    );
	  };
	
	  return Downloads;
	}(_react.Component);
	
	exports.default = Downloads;
	module.exports = exports["default"];

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var features = [{
	  icon: __webpack_require__(402),
	  text: "Auto Führerschein (Klasse B), Motorrad Führerschein (Klasse A, A1, A2, AM und Mofa), Bus und LKW Führerschein (Klasse C, C1, CE, D, D1, L,T)"
	}, {
	  icon: __webpack_require__(403),
	  text: "Die sicherste Vorbereitung auf die Prüfung zum Führerschein."
	}, {
	  icon: __webpack_require__(404),
	  text: "AKTUELLSTER AMTLICHER KATALOG INKL: VIDEOS - inkl. Updates vom 1.4.2017 und 1.10.2017"
	}];
	
	var Features = function (_Component) {
	  _inherits(Features, _Component);
	
	  function Features() {
	    _classCallCheck(this, Features);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Features.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "features-container" },
	      features.map(function (f, i) {
	        return _react2.default.createElement(
	          "div",
	          { key: i, className: "feature" },
	          _react2.default.createElement("img", { src: f.icon }),
	          _react2.default.createElement(
	            "p",
	            null,
	            f.text
	          )
	        );
	      })
	    );
	  };
	
	  return Features;
	}(_react.Component);
	
	exports.default = Features;
	module.exports = exports["default"];

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      {
	        style: {
	          width: "100%",
	          paddingTop: "2em",
	          paddingBottom: "2em",
	          backgroundColor: "#337ab7",
	          color: "white",
	          textAlign: "center"
	        }
	      },
	      "Swift Management AG, Basel, Switzerland \xA9 2018",
	      " "
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLUdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMjEuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKS0tPgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIGlkPSJFYmVuZV8xIiB4PSIwcHgiIHk9IjBweCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTEzLjQgMTEzLjQ7IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAxMTMuNCAxMTMuNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CiAgICA8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgogICAgICAgIC5zdDB7ZmlsbDojMzM3YWI3O30KICAgIDwvc3R5bGU+CiAgICA8dGl0bGU+CiAgICAgICAgb2ZmaXppZWxsCiAgICA8L3RpdGxlPgogICAgPHBhdGggZD0iTTgyLjYsNjYuMmMtMi44LTIuMy02LjYtMi4xLTEwLTEuOXMtNi4zLDAuMy04LjEtMS42bC0wLjEtMC4xYy0wLjgtMC45LTIuMi0yLjQtMi40LTEyLjgKCWMtMC4yLTMuOSwwLjQtNy43LDEuOC0xMS40YzAuMy0wLjcsMC41LTEuNSwwLjgtMi4zYzAtMC4xLDAuMS0wLjEsMC4xLTAuMmMwLjQtMS4yLDAuNi0yLjQsMC43LTMuN2MwLjItNS42LTQuMi0xMC4yLTkuOC0xMC40CgljLTUuNi0wLjItMTAuMiw0LjItMTAuNCw5LjhjMCwwLjIsMCwwLjQsMCwwLjZjMC4xLDEuNSwwLjQsMi45LDAuOSw0LjJjMC4yLDAuOSwwLjUsMS44LDAuOCwyLjdjMS4zLDMuNiwxLjksNy41LDEuNywxMS40CgljLTAuMiwxMC40LTEuNSwxMS45LTIuNCwxMi44bC0wLjEsMC4xYy0xLjgsMi00LjgsMS44LTguMSwxLjZjLTMuNi0wLjItNy42LTAuNC0xMC40LDIuM1MyNC43LDgwLDI1LDgzLjFjMCwwLjUsMC40LDAuOCwwLjksMC44aDIKCWMwLDAsMCwwLjEsMCwwLjF2MmMwLDEsMC44LDEuOCwxLjgsMS44aDUxLjRjMSwwLDEuOC0wLjgsMS44LTEuOHYtMmMwLDAsMC0wLjEsMC0wLjFoMS43YzAuNSwwLDAuOS0wLjQsMC45LTAuOAoJYzAuMy0yLjgsMC4zLTEzLjgtMi43LTE2LjdDODIuOCw2Ni4zLDgyLjcsNjYuMyw4Mi42LDY2LjJ6IE04MS4xLDg0LjF2MS45SDI5Ljh2LTEuOWMwLjIsMCwwLjQtMC4xLDAuNS0wLjJoNTAuMwoJQzgwLjgsODQuMSw4MC45LDg0LjEsODEuMSw4NC4xeiBNODMuOCw4Mi4xSDI2LjhjLTAuMi00LjEsMC4zLTExLjUsMi4yLTEzLjRjMi4yLTIuMiw1LjUtMiw5LTEuOHM3LjIsMC40LDkuNi0yLjJsMC4xLTAuMQoJYzEuNC0xLjYsMi42LTMuNywyLjktMTRjMC4yLTQuMS0wLjQtOC4yLTEuOC0xMmMtMC4zLTAuOS0wLjYtMS43LTAuOC0yLjZsMCwwbDAsMGMtMC41LTEuMi0wLjgtMi40LTAuOC0zLjZjMC00LjUsMy43LTguMiw4LjItOC4yCglzOC4yLDMuNyw4LjIsOC4yYzAsMC45LTAuMiwxLjktMC41LDIuOGMwLDAuMS0wLjEsMC4xLTAuMSwwLjJjLTAuMywwLjktMC42LDEuOC0wLjgsMi42Yy0xLjUsMy44LTIuMSw3LjktMS45LDEyCgljMC4yLDEwLjMsMS40LDEyLjQsMi45LDE0bDAuMSwwLjFjMi40LDIuNiw2LDIuNCw5LjYsMi4yczYuOC0wLjQsOSwxLjhjMC4xLDAuMSwwLjEsMC4xLDAuMiwwLjFDODMuNiw3MC41LDg0LDc4LjMsODMuOCw4Mi4xCglMODMuOCw4Mi4xeiIgY2xhc3M9InN0MCIvPgogICAgPHBhdGggZD0iTTg4LjgsMEgyNC41QzExLDAsMCwxMSwwLDI0LjV2NjQuM2MwLDEzLjUsMTEsMjQuNSwyNC41LDI0LjVoNjQuM2MxMy41LDAsMjQuNS0xMSwyNC41LTI0LjVWMjQuNQoJQzExMy4zLDExLDEwMi40LDAsODguOCwweiBNMTExLjUsODguOWMwLDEyLjUtMTAuMSwyMi42LTIyLjcsMjIuN0gyNC41Yy0xMi41LDAtMjIuNy0xMC4xLTIyLjctMjIuNmMwLDAsMCwwLDAsMFYyNC41CglDMS44LDEyLDEyLDEuOSwyNC41LDEuOWMwLDAsMCwwLDAsMGg2NC4zYzEyLjUsMCwyMi42LDEwLjEsMjIuNywyMi43Vjg4Ljl6IiBjbGFzcz0ic3QwIi8+Cjwvc3ZnPgo="

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/de_auto_premium.cc04c96c.png";

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(85);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _itheorydeComingSoon = __webpack_require__(406);
	
	var _itheorydeComingSoon2 = _interopRequireDefault(_itheorydeComingSoon);
	
	var _de_auto_premium = __webpack_require__(405);
	
	var _de_auto_premium2 = _interopRequireDefault(_de_auto_premium);
	
	__webpack_require__(267);
	
	var _footer = __webpack_require__(181);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _downloads = __webpack_require__(179);
	
	var _downloads2 = _interopRequireDefault(_downloads);
	
	var _features = __webpack_require__(180);
	
	var _features2 = _interopRequireDefault(_features);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: "container" },
	    _react2.default.createElement(
	      "div",
	      { className: "header", style: { backgroundImage: "url(" + _itheorydeComingSoon2.default + ")" } },
	      _react2.default.createElement(
	        "div",
	        { className: "header-container" },
	        _react2.default.createElement("img", { src: _de_auto_premium2.default, className: "app-icon" }),
	        _react2.default.createElement(
	          "h1",
	          null,
	          "iTheorie F\xFChrerschein Auto "
	        ),
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Die beste Weg, um f\xFCr die Theoriepr\xFCfung zu lernen."
	        ),
	        _react2.default.createElement(_downloads2.default, null)
	      )
	    ),
	    _react2.default.createElement("img", { src: __webpack_require__(407) }),
	    _react2.default.createElement(_features2.default, null),
	    _react2.default.createElement(_footer2.default, null)
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/itheoryde-coming-soon.53823f5c.jpeg";

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screenshot.71a9be03.png";

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-169abb4a4a7427868fe9.js